<div *ngFor="let package of latestVersions"
     class="nuget-version-container">
    <ui-nuget-changelog [package]="package"
                        [type]="type"
                        [isDownloadEnabled]="isDownloadEnabled"
                        [downloadLink]="downloadLink(package)">
    </ui-nuget-changelog>
</div>
